import api, { Pagination } from '..'

export class CreditLineDeadlineService {
  static async findAllForRefunds(
    organizationId: string,
    pagination: Pagination
  ) {
    const response = await api.get(
      `/credit-line-deadlines?organizationId=${organizationId}&populate=creditLine,refundTransaction&page=${pagination.page}&perPage=${pagination.perPage}`
    )
    return response.data
  }
}
